var _a;
export var MUTATIONS = {
    SET_MOBILE_MENU_OPEN: 'SET_MOBILE_MENU_OPEN',
    TOGGLE_MOBILE_MENU: 'TOGGLE_MOBILE_MENU'
};
export var mobileMenuModule = {
    state: {
        isOpen: false
    },
    mutations: (_a = {},
        _a[MUTATIONS.SET_MOBILE_MENU_OPEN] = function (state, isOpen) {
            state.isOpen = isOpen;
        },
        _a[MUTATIONS.TOGGLE_MOBILE_MENU] = function (state) {
            state.isOpen = !state.isOpen;
        },
        _a)
};
